export default function PageHeader({ overline, title, subtitle }) {
    return (
        <section className="pt-16 sm:pt-24 pb-8 sm:pb-12 bg-white border-b border-[var(--ns-border)]">
            <div className="container-ns">
                <div className="max-w-3xl fade-up">
                    {overline && (
                        <div className="overline mb-4">{overline}</div>
                    )}
                    <h1 className="font-display font-black text-[var(--ns-text)] text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] mb-5">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-lg sm:text-xl text-[var(--ns-muted)] leading-relaxed max-w-2xl">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
}
